module.exports = __webpack_public_path__ + "img/CrimsonText-Italic.170d7230.svg";